// const apiBaseUrl = "https://dp.supremesalesforce.in:6884/api";
 const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;    
//  const apiBaseUrl = "https://localhost:7335/api";

// export const loginUser = `${apiBaseUrl}/Login/login`;
export const userLogs=`${apiBaseUrl}/Login/log`;
export const getItemGroup = `${apiBaseUrl}/ItemPage/GetItemGroup?databaseName=`;
export const getItem = `${apiBaseUrl}/ItemPage/GetItemByGroup?databaseName=`;
export const PostCartItemApi =`${apiBaseUrl}/ItemPage/InsertOrUpdateCartItems?userId=`;
export const getCartItemApi = `${apiBaseUrl}/ItemPage/GetCartItem?userId=`;
export const removeItemInTable = `${apiBaseUrl}/ItemPage/RemoveCartItems?userId=`;

export const SoPostApi = `${apiBaseUrl}/CheckoutPage/InsertSalesOrder`;
export const PostSalesQuotation = `${apiBaseUrl}/CheckoutPage/InsertSalesQuotation`;
export const UpdateSalesQuotation=`${apiBaseUrl}/CheckoutPage/updateSaleQuotation`
export const postUpdateSalesQuotation=`${apiBaseUrl}/SalesQuotation/UpdateSalesQuotattion`;

export const getItembySearchWithTotal = `${apiBaseUrl}/ItemPage/GetItemBySearch?searchText=`
export const getItembySearchTable = `${apiBaseUrl}/ItemPage/GetItemTableSearch?searchText=`
export const GetPriceList = `${apiBaseUrl}/WGDealer/GetItemPriceList?ItemCode=`;
export const SapConnection = `${apiBaseUrl}/Login/SapConnection?companyName=`;
export const SapDisconnection = `${apiBaseUrl}/Login/DisconnectSap?companyName=`;
export const RefreshToken = `${apiBaseUrl}/Login/refresh-token?refreshToken=`;

export const getAllReport=`${apiBaseUrl}/Report/GetAllReports?DatabaseName=`;
export const getReportId=`${apiBaseUrl}/Report/GetReportsById?ReportId=`;
export const getReportData=`${apiBaseUrl}/Report/ReportData?reportId=`;

export const getSQHistory=`${apiBaseUrl}/OrderHistory/GetSQHistory?DatabaseName=`;
export const getSOHistory=`${apiBaseUrl}/OrderHistory/GetSOHistory?DatabaseName=`;
export const getHistortyItems=`${apiBaseUrl}/OrderHistory/GetHistoryItem?DatabaseName=`
// export const tableAPI =`${apiBaseUrl}/CrmOpportunity/GetCrmOpporStage?DatabaseName=Live_TpTilesandSanitaries&OpprId=5536`
export const customerDataAPI = `${apiBaseUrl}/Master/GetBpMaster?DatabaseName=`
export const printDataAPI=`${apiBaseUrl}/PrintReport/ReportData?DatabaseName=`;